import React, { useEffect, useState } from 'react';
import { apiClient } from '../../services/api';
import EmptyState from '../shared/EmptyState';
import './QAProductivitySummary.css';

export const QAProductivitySummary: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [throughputPerDay, setThroughputPerDay] = useState<number | null>(null);
  const [adoption, setAdoption] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      apiClient.get('/api/v1/dashboard/activity-report?period=monthly&view=overall&months_back=1'),
      apiClient.get('/api/v1/dashboard/ai-productivity?days=30'),
    ])
      .then(([actResp, aiResp]) => {
        if (cancelled) return;
        const rows = (actResp.data as any).rows || [];
        const row = rows[0];
        const created = (row?.tc_created ?? 0) + (row?.sc_created ?? 0);
        setThroughputPerDay(Math.round((created / 30) * 10) / 10);
        setAdoption((aiResp.data as any).adoption_percentage ?? 0);
      })
      .catch(() => { if (!cancelled) { setThroughputPerDay(null); setAdoption(null); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="qap-card">
      <div className="qap-header"><h3>QA Productivity</h3></div>
      {loading ? (
        <div className="qap-skeleton" />
      ) : throughputPerDay === null ? (
        <EmptyState message="No productivity data yet." compact />
      ) : (
        <div className="qap-metrics">
          <div className="qap-metric" title="Average test cases + scenarios created per day, last 30 days.">
            <span className="qap-metric-value">{throughputPerDay}</span>
            <span className="qap-metric-label">Items created / day</span>
          </div>
          <div className="qap-metric" title="% of items created in the last 30 days that were AI-generated.">
            <span className="qap-metric-value">{adoption}%</span>
            <span className="qap-metric-label">AI-assisted</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default QAProductivitySummary;
